// extracted by mini-css-extract-plugin
export var hero = "contact-page-module--hero--l5JWh";
export var heroContainer = "contact-page-module--heroContainer--bAzrC";
export var section = "contact-page-module--section--aWJhq";
export var sectionImage = "contact-page-module--sectionImage--XpEAj";
export var sectionFigure = "contact-page-module--sectionFigure--6xkyY";
export var sectionColumn = "contact-page-module--sectionColumn--k5JIc";